module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('ni-icon', {
    attrs: {
      "icon": _vm.env[_vm.env_code] ? _vm.env[_vm.env_code].icon : _vm.env.default.icon,
      "size": "mini",
      "iconStyle": _vm.env.default.icon_style
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "title": _vm.env_text
    }
  }, [_vm._v(_vm._s(_vm.env_text))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-7f317009","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/omnis-business/env-item/env-item.vue
// module id = rT7V
// module chunks = 81